import { EventAnalytics } from "@models/analytics-event";
import Component from "../component.abstract";
import { isParent } from "../helpers/html-utils";

interface TabLayoutProps {
  loadOnShow?: boolean;
  trackingsLoad: EventAnalytics;
}

export default class TabLayout extends Component {
  private id: string;
  private loadOnShow: boolean;
  public content: ChildNode;

  constructor(private props: TabLayoutProps, element: HTMLElement) {
    super(props, element);
    this.id = element.id;
    this.loadOnShow = props.loadOnShow || (this.element.hasAttribute("data-load-on-show") && this.element.getAttribute("data-load-on-show") === "true");
    this.content = this.getContent(this.element);
  }

  mounted(): void {
    this.element.addEventListener("change", () => {
         window.location.hash = this.id;
         if (typeof this.props.trackingsLoad !== "undefined") {
           this.tracking(this.props.trackingsLoad);
         }
         PubSub.publish("Tablayout.changed", this)
    })
    const hash = window.location.hash;
    if (hash) {
      const hashsub = hash.substring(1);
      if (hashsub + "" === this.id + "") {
        (<HTMLInputElement>this.element).checked = true;
      }
    }
     PubSub.publish("Tablayout.changed", this)
  }
  getContent(tab:HTMLElement): ChildNode {
        return tab.nextElementSibling.nextElementSibling;
  }
  tracking(eventAnalytics : EventAnalytics):void {
         window.dataLayer = window.dataLayer || [];
         window.dataLayer.push(eventAnalytics);
  }
  isShowing():boolean {
       return (<HTMLInputElement>this.element).checked;
  }
  isParent(element:HTMLElement, tab: HTMLElement):boolean {
       return isParent(element, this.getContent(tab))
   }
}